import { useMemo } from 'react'

/**
 * @param {string | string[]} label
 * @returns {*|[*,*]|null[]|[*,*]}
 */
export const useTitle = (label) => {
  return useMemo(() => {
    if (Array.isArray(label)) {
      if (label.length > 1) {
        return label
      } else if (label.length === 1) {
        return [label[0], label[0]]
      }
      return [null, null]
    }
    return [label, label]
  }, [label])
}
